<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="申请人信息：" prop="applicantInfo">
            <el-input v-model="query.applicantInfo" placeholder="请输入姓名/手机号" size="small" clearable />
          </el-form-item>
          <el-form-item label="申请人身份：">
            <el-select v-model="query.applicantIdentity" placeholder="全部" clearable size="small" style="width: 120px;">
              <el-option v-for="item in identityList" :key="item.id" :label="item.name" :value="item.level" />
            </el-select>
          </el-form-item>
          <el-form-item label="发票类型：">
            <el-select v-model="query.invoiceType" placeholder="全部" clearable size="small" style="width: 140px;">
              <!-- REQ-2026-639960：票种值对齐后端 customer_order_invoice.type（1普票 2专票）。
                   原来这里传的是 electronic_ordinary / vat_special 两个字符串，而后端 QO 的 type 是 Integer，
                   传过去根本筛不出东西，本期一并改成数字。 -->
              <el-option label="电子普通发票" :value="1" />
              <el-option label="增值税专用发票" :value="2" />
            </el-select>
          </el-form-item>
          <el-form-item label="城市公司：" prop="cityCompany">
            <el-input v-model="query.cityCompany" placeholder="请输入城市公司" size="small" clearable />
          </el-form-item>
          <el-form-item label="付款方式：">
            <el-select v-model="query.orderPayType" placeholder="全部" clearable size="small" style="width: 140px;">
              <el-option label="零售价支付" :value="1" />
              <el-option label="余额账户支付" :value="2" />
              <el-option label="积分账户支付" :value="3" />
              <el-option label="赠送账户支付" :value="4" />
              <el-option label="在线支付" :value="5" />
              <el-option label="组合支付" :value="6" />
            </el-select>
          </el-form-item>
          <el-form-item label="时间筛选：">
            <el-select v-model="query.timeType" placeholder="请选择" clearable size="small" style="width: 120px;">
              <el-option label="申请时间" :value="1" />
              <el-option label="审核时间" :value="2" />
            </el-select>
            <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始" end-placeholder="结束" style="margin-left: 10px;" />
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <el-tabs v-model="activeName" @tab-click="doQueryList({ pageNo: 1 })">
          <el-tab-pane label="待审核" name="0" />
          <el-tab-pane label="开票中" name="1" />
          <el-tab-pane label="已开票" name="2" />
          <el-tab-pane label="开票失败" name="3" />
        </el-tabs>
        <div class="btn-box">
          <el-button type="primary" plain size="mini" @click="handleExport">导出</el-button>
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" :key="activeName" style="width: 100%">
        <el-table-column label="申请人" align="center" width="100">
          <template slot-scope="{ row }">
            {{ row.name || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="申请人身份" align="center" width="100">
          <template slot-scope="{ row }">
            {{ row.identity || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="申请人手机号" align="center" width="120">
          <template slot-scope="{ row }">
            {{ row.pho || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="城市公司" prop="cityName" align="center" width="140" show-overflow-tooltip />
        <el-table-column label="订单编号" prop="ordernum" align="center" width="140" show-overflow-tooltip />
        <el-table-column label="订单类型" align="center" width="100" show-overflow-tooltip>
          <template slot-scope="{ row }">
            {{ row.ordertype || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="订单状态" align="center" width="100" show-overflow-tooltip>
          <template slot-scope="{ row }">
            {{ row.orderstate || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="发票类型" align="center" width="120" show-overflow-tooltip>
          <template slot-scope="{ row }">
            {{ row.type || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="发票内容" prop="invoiceContent" align="center" width="100" show-overflow-tooltip />
        <el-table-column label="抬头类型" align="center" width="80">
          <template slot-scope="{ row }">
            {{ row.titleType || '-' }}
          </template>
        </el-table-column>
        <el-table-column label="抬头名称" prop="title" align="center" width="120" show-overflow-tooltip />
        <el-table-column label="税号" prop="taxid" align="center" width="140" show-overflow-tooltip />
        <el-table-column label="申请商品数量" align="center" width="110">
          <template slot-scope="{ row }">
            {{ row.goodsCount || 0 }}
          </template>
        </el-table-column>
        <el-table-column label="开票金额" align="center" width="100">
          <template slot-scope="{ row }">
            {{ formatAmount(row.totalPrice) }}
          </template>
        </el-table-column>
        <el-table-column label="订单时间" prop="orderTime" align="center" width="180" />
        <el-table-column label="申请时间" prop="createTime" align="center" width="180" />
        <el-table-column label="审核时间" prop="auditTime" align="center" width="180" />
        <el-table-column label="付款方式" prop="orderPayTypeStr" align="center" width="120" />
        <el-table-column label="付款金额" align="center" width="140">
          <template slot-scope="{ row }">
            <div v-if="row.payDetail" style="white-space: pre-line; text-align: left;">{{ row.payDetail }}</div>
            <span v-else>{{ formatAmount(row.allPayMoney) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="付款时间" prop="payTime" align="center" width="180" />
        <el-table-column v-if="activeName === '2'" label="开票时间" prop="invoiceTime" align="center" width="180" />
        <el-table-column label="状态" align="center" width="100">
          <template slot-scope="{ row }">
            {{ invoiceStateText(row) || '-' }}
          </template>
        </el-table-column>
        <el-table-column v-if="activeName === '0'" label="操作" align="center" fixed="right" width="260">
          <template slot-scope="{ row }">
            <el-button type="text" @click="handleApprove(row)">同意</el-button>
            <el-button type="text" @click="handleReject(row)">驳回</el-button>
            <el-button type="text" @click="handleViewDetail(row)">查看详情</el-button>
            <!-- REQ-2026-639960：申请专票的才需要核验资质 -->
            <el-button v-if="row.typeValue === 2" type="text" @click="handleCheckQualification(row)">核验专票资质</el-button>
          </template>
        </el-table-column>
        <el-table-column v-if="activeName !== '0'" label="操作" align="center" fixed="right" :width="activeName === '1' ? 180 : 100">
          <template slot-scope="{ row }">
            <el-button v-if="activeName === '1'" type="text" @click="$refs.manualInvoiceDialog.handleCreate(row)">上传发票</el-button>
            <el-button type="text" @click="handleViewDetail(row)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>

      <pagination v-show="total > 0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize"
        @pagination="doQueryList" />
    </el-card>

    <approve-dialog ref="approveDialog" @approve="handleApproveConfirm" />
    <reject-dialog ref="rejectDialog" @reject="handleRejectConfirm" />
    <manual-invoice-dialog ref="manualInvoiceDialog" @completed="doQueryList({})" />
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import invoiceApplicationAuditApi from '@/api/finance/invoiceApplicationAudit'
import ApproveDialog from './approveDialog.vue'
import RejectDialog from './rejectDialog.vue'
import ManualInvoiceDialog from './ManualInvoiceDialog.vue'
import { invoiceStateText } from './manualInvoice'

export default {
  components: {
    Pagination,
    ApproveDialog,
    RejectDialog,
    ManualInvoiceDialog
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 20,
        applicantInfo: undefined,
        applicantIdentity: undefined,
        invoiceType: undefined,
        cityCompany: undefined,
        timeType: 1,
        state: undefined
      },
      dateTime: null,
      activeName: '0',
      identityList: []
    }
  },
  created() {
    this.identityList = JSON.parse(localStorage.getItem('levelList') || '[]')
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    invoiceStateText,
    handleFilter() {
      this.query = {
        pageNo: 1,
        pageSize: 20,
        applicantInfo: undefined,
        applicantIdentity: undefined,
        invoiceType: undefined,
        cityCompany: undefined,
        timeType: 1,
        orderPayType: undefined,
        state: undefined
      }
      this.dateTime = null
      this.doQueryList({ pageNo: 1 })
    },
    handleQuery() {
      this.doQueryList({ pageNo: 1 })
    },
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) this.query.pageNo = pageNo
      if (pageSize) this.query.pageSize = pageSize
      this.query.state = this.activeName

      const params = {
        pageNo: this.query.pageNo,
        pageSize: this.query.pageSize,
        state: this.query.state
      }
      
      if (this.query.applicantInfo) {
        if (/^\d+$/.test(this.query.applicantInfo.trim())) {
          params.namePhone = this.query.applicantInfo.trim()
        } else {
          params.namePhone = this.query.applicantInfo.trim()
        }
      }
      
      if (this.query.applicantIdentity !== undefined && this.query.applicantIdentity !== '') {
        params.levelId = this.query.applicantIdentity
      }
      
      if (this.query.invoiceType !== undefined && this.query.invoiceType !== '' && this.query.invoiceType !== null) {
        params.type = this.query.invoiceType
      }

      if (this.query.orderPayType !== undefined && this.query.orderPayType !== '') {
        params.orderPayType = this.query.orderPayType
      }

      if (this.query.cityCompany) {
        params.cityCompany = this.query.cityCompany
      }

      if (this.dateTime && this.dateTime.length === 2) {
        params.timeType = this.query.timeType || 1
        params.startTime = this.dateTime[0]
        params.endTime = this.dateTime[1]
      }

      this.listLoading = true
      invoiceApplicationAuditApi
        .fetchList(params)
        .then(data => {
          if (data && data.data) {
            this.list = data.data.list || []
            this.total = data.data.total || 0
          } else {
            this.list = []
            this.total = 0
          }
        })
        .catch(() => {
          this.list = []
          this.total = 0
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    formatAmount(val) {
      if (val === null || val === undefined || val === '') return '-'
      const num = Number(val)
      return isNaN(num) ? val : num
    },
    handleApprove(row) {
      this.$refs.approveDialog.handleCreate(row)
    },
    handleApproveConfirm(params, callback) {
      invoiceApplicationAuditApi
        .approve(params)
        .then(() => {
          this.$message.success('审核通过')
          this.doQueryList({})
          if (callback) callback()
        })
        .catch(err => {
          this.$message.error(err.msg || '审核失败')
          if (callback) callback()
        })
    },
    handleReject(row) {
      this.$refs.rejectDialog.handleCreate(row)
    },
    handleRejectConfirm(params, callback) {
      invoiceApplicationAuditApi
        .reject(params)
        .then(() => {
          this.$message.success('已驳回')
          this.doQueryList({})
          if (callback) callback()
        })
        .catch(err => {
          this.$message.error(err.msg || '驳回失败')
          if (callback) callback()
        })
    },
    handleViewDetail(row) {
      this.$emit('handleShow', row.invoiceId, row)
    },
    // REQ-2026-639960：核验申请人是否具备开专票资质（按纳税人类型判定，并校验抬头类型必须是单位）
    handleCheckQualification(row) {
      invoiceApplicationAuditApi
        .checkSpecialQualification({ invoiceId: row.invoiceId })
        .then(data => {
          const info = (data && data.data) || {}
          const lines = [
            '核验结论：' + (info.qualified ? '具备专票资质' : '不具备专票资质'),
            '纳税人类型：' + (info.taxpayerTypeStr || '未标记'),
            '企业名称：' + (info.companyName || '-'),
            '纳税人识别号：' + (info.taxpayerCode || '-'),
            '说明：' + (info.message || '-')
          ]
          if (info.applyValid === false) {
            lines.push('⚠ 本次专票申请不符合开票要求，请勿直接通过')
          }
          this.$alert(lines.join('<br/>'), '专票资质核验', {
            dangerouslyUseHTMLString: true,
            type: info.qualified ? 'success' : 'warning'
          })
        })
        .catch(err => {
          this.$message.error((err && err.msg) || '核验失败')
        })
    },
    handleExport() {
      // BUG-2026-581958：这个 code 必须与后端 downloadCustomerOrderInvoiceList 里
      // dto.setCode(...) 写进 sys_task 的字面量完全一致 —— 它同时决定
      // ①导出中心挂哪个表单组件 ②任务列表按哪个 code 去筛。
      // 原来写的 'InvoiceApplicationAuditExport' 两头都对不上：没有对应组件（页面空白），
      // 也筛不到任务（列表永远为空），而且全程不报错。
      this.$router.push('/export/list?code=downloadCustomerOrderInvoiceList')
    }
  }
}
</script>

<style scoped>
.btn-right-side {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.mt10 {
  margin-top: 10px;
}

.mb10 {
  margin-bottom: 10px;
}
</style>
